// SPDX-License-Identifier: AGPL-3.0-only

export interface HorizontalTooltipBounds {
  readonly left: number;
  readonly right: number;
}

export function clampTooltipPosition(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

export function horizontalTooltipBounds(
  targetElement: HTMLElement,
  containerSelector: string,
  viewportMarginPx: number,
): HorizontalTooltipBounds {
  const containerElement: Element | null = targetElement.closest(containerSelector);
  const viewportLeft: number = viewportMarginPx;
  const viewportRight: number = window.innerWidth - viewportMarginPx;
  if (containerElement === null) return { left: viewportLeft, right: viewportRight };
  const containerBounds: DOMRect = containerElement.getBoundingClientRect();
  return {
    left: Math.max(viewportLeft, containerBounds.left),
    right: Math.min(viewportRight, containerBounds.right),
  };
}
